import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  BokkzAlgDataService,
  BokkzDivDataService,
  Dividendbelasting,
  DividendTaxEntity,
  OpgaafSpecificatie
} from "@snelstart-ventures/fiscaal/domain-logic";
import {FormArray, FormBuilder, FormGroup} from "@angular/forms";
import {SharedUiDetailsModule} from "@snelstart/ui-details";
import {SelectFormControlItem, SharedUiFormControlsModule} from "@snelstart/ui-form-controls";
import {SharedUiButtonModule} from "@snelstart/ui-button";
import {SharedUiDialogModule} from "@snelstart/ui-dialog";
import {Subscription} from "rxjs";

@Component({
  selector: 'snelstart-venture-fiscaal-opgaafdividend',
  standalone: true,
  imports: [CommonModule, SharedUiDetailsModule, SharedUiFormControlsModule, SharedUiButtonModule, SharedUiDialogModule],
  templateUrl: './opgaaf.component.html',
  styleUrl: './opgaaf.component.scss',
})
export class OpgaafComponent implements OnInit, OnDestroy {

  @Input() public id!: string;
  private divTaxEntitySubscription: Subscription | undefined;
  public divTaxEntity = {} as DividendTaxEntity;
  public aangifte = {} as Dividendbelasting;
  public opgaafFg = {} as FormGroup;
  public index = 0;
  public formStructure: any;
  public focusedElementId: string | null = null;
  public dialogVisible = false;

  public optionsLandcodes: SelectFormControlItem<string>[] = [
    {value: "ALB", label: "Albanië"},
    {value: "ARG", label: "Argentinië"},
    {value: "ARM", label: "Armenië"},
    {value: "ABW", label: "Aruba"},
    {value: "AUS", label: "Australië"},
    {value: "AZE", label: "Azerbeidjan"},
    {value: "BHR", label: "Bahrein"},
    {value: "BGD", label: "Bangladesh"},
    {value: "BRB", label: "Barbedos"},
    {value: "BLR", label: "Belarus (Wit-Rusland)"},
    {value: "BEL", label: "België"},
    {value: "BMU", label: "Bermuda"},
    {value: "BES", label: "Bonaire, St. Eustatius en Saba"},
    {value: "BIH", label: "Bosnië-Herzegovina"},
    {value: "BRA", label: "Brazilië"},
    {value: "BGR", label: "Bulgarije"},
    {value: "CAN", label: "Canada"},
    {value: "CHN", label: "China"},
    {value: "CUW", label: "Curaçao"},
    {value: "CYP", label: "Cyprus"},
    {value: "DNK", label: "Denemarken"},
    {value: "DEU", label: "Duitsland"},
    {value: "EGY", label: "Egypte"},
    {value: "EST", label: "Estland"},
    {value: "PHL", label: "Filippijnen"},
    {value: "FIN", label: "Finland"},
    {value: "FRA", label: "Frankrijk"},
    {value: "GEO", label: "Georgië"},
    {value: "GHA", label: "Ghana"},
    {value: "GRC", label: "Griekenland"},
    {value: "HUN", label: "Hongarije"},
    {value: "HKG", label: "Hongkong"},
    {value: "IRL", label: "Ierland"},
    {value: "ISL", label: "IJsland"},
    {value: "IND", label: "India"},
    {value: "IDN", label: "Indonesië"},
    {value: "ISR", label: "Israël"},
    {value: "ITA", label: "Italië"},
    {value: "JPN", label: "Japan"},
    {value: "JOR", label: "Jordanië"},
    {value: "KAZ", label: "Kazachstan"},
    {value: "KGZ", label: "Kirgizië"},
    {value: "KGZ", label: "Kirgizië"},
    {value: "KWT", label: "Koeweit"},
    {value: "HRV", label: "Kroatië"},
    {value: "LVA", label: "Letland"},
    {value: "LTU", label: "Litouwen"},
    {value: "LUX", label: "Luxemburg"},
    {value: "MKD", label: "Macedonië"},
    {value: "MWI", label: "Malawi"},
    {value: "MYS", label: "Maleisië"},
    {value: "MLT", label: "Malta"},
    {value: "MAR", label: "Marokko"},
    {value: "MEX", label: "Mexico"},
    {value: "MDA", label: "Moldavië"},
    {value: "MNE", label: "Montenegro"},
    {value: "NZL", label: "Nieuw-Zeeland"},
    {value: "NGA", label: "Nigeria"},
    {value: "NOR", label: "Noorwegen"},
    {value: "UKR", label: "Oekraïne"},
    {value: "UZB", label: "Oezbekistan"},
    {value: "OMN", label: "Oman"},
    {value: "AUT", label: "Oostenrijk"},
    {value: "PAK", label: "Pakistan"},
    {value: "PAN", label: "Panama"},
    {value: "POL", label: "Polen"},
    {value: "PRT", label: "Portugal"},
    {value: "QAT", label: "Qatar"},
    {value: "ROU", label: "Roemenië"},
    {value: "RUS", label: "Rusland"},
    {value: "SAU", label: "Saudi-Arabië"},
    {value: "SRB", label: "Servië"},
    {value: "SGP", label: "Singapore"},
    {value: "SXM", label: "Sint Maarten"},
    {value: "SVN", label: "Slovenië"},
    {value: "SVK", label: "Slowakije"},
    {value: "ESP", label: "Spanje"},
    {value: "LKA", label: "Sri Lanka"},
    {value: "SUR", label: "Suriname"},
    {value: "TJK", label: "Tadzjikistan"},
    {value: "TWN", label: "Taiwan"},
    {value: "THA", label: "Thailand"},
    {value: "CZE", label: "Tsjechië"},
    {value: "TUN", label: "Tunesië"},
    {value: "TUR", label: "Turkije"},
    {value: "UGA", label: "Uganda"},
    {value: "VEN", label: "Venezuela"},
    {value: "GBR", label: "Verenigd Koninkrijk"},
    {value: "ARE", label: "Verenigde Arabische Emiraten"},
    {value: "USA", label: "Verenigde Staten van Amerika"},
    {value: "VNM", label: "Vietnam"},
    {value: "ZMB", label: "Zambia"},
    {value: "ZWE", label: "Zimbabwe"},
    {value: "ZAF", label: "Zuid-Afrika"},
    {value: "KOR", label: "Zuid-Korea"},
    {value: "SWE", label: "Zweden"},
    {value: "CHE", label: "Zwitserland"}
  ];

  constructor(
    public algDataService: BokkzAlgDataService,
    public dataService: BokkzDivDataService,
    private fb: FormBuilder) {
    this.opgaafFg = this.fb.group({
      bedragDividenduitkering: null as unknown as number,
      bedragNominaalGestortKapitaal: null as unknown as number,
      totaalAantalStemgerechtigdeAandelen: null as unknown as number,
      opgaafSpecificaties: this.fb.array<OpgaafSpecificatie>([]),
    })
  }

  showDialog(index: number) {
    this.index = index;
    this.dialogVisible = true;
  }

  get opgaafSpecificatie(): FormArray {
    return this.opgaafFg.get('opgaafSpecificaties') as FormArray;
  }

  addRij(): void {
    this.opgaafSpecificatie.push(this.createFormGroup());
  }

  verwijderRij(index: number): void {
    this.opgaafSpecificatie.removeAt(index);
    this.saveForm()
  }

  createFormGroup(item?: OpgaafSpecificatie): FormGroup {
    return this.fb.group<OpgaafSpecificatie>({
      indicatieAchterliggendePartijIsHybrideEntiteit: item ? item.indicatieAchterliggendePartijIsHybrideEntiteit : false,
      indicatieHybrideEntiteit: item ? item.indicatieHybrideEntiteit : false,
      bedragVrijgesteldeUitkering: item ? item.bedragVrijgesteldeUitkering : null as unknown as number,
      bedragNominaalGestortKapitaal: item ? item.bedragNominaalGestortKapitaal : null as unknown as number,
      aantalStemgerechtigdeAandelen: item ? item.aantalStemgerechtigdeAandelen : null as unknown as number,
      percentageStemrechten: item ? item.percentageStemrechten : null as unknown as number,
      fiscaalNummerGerechtigde: item ? item.fiscaalNummerGerechtigde : null as unknown as string,
      naamGerechtigde: item ? item.naamGerechtigde : null as unknown as string,
      straatGerechtigde: item ? item.straatGerechtigde : null as unknown as string,
      huisNummerGerechtigde: item ? item.huisNummerGerechtigde : null as unknown as string,
      postCodeGerechtigde: item ? item.postCodeGerechtigde : null as unknown as string,
      woonplaatsGerechtigde: item ? item.woonplaatsGerechtigde : null as unknown as string,
      landCode: item ? item.landCode : null as unknown as string,
    });
  }

  trackByFn(index: number): any {
    return index;
  }

  ngOnInit(): void {
   this.divTaxEntitySubscription = this.dataService.dividendTaxEntity.subscribe((value)=> {
      this.divTaxEntity = value;
      this.aangifte = value.aangifte!;
      if (this.aangifte.opgaafDb?.opgaafSpecificaties) {
        this.opgaafFg.patchValue(this.aangifte.opgaafDb?.opgaafSpecificaties, {emitEvent: false})
        this.updateForm();
      }
    })
  }

  ngOnDestroy(): void {
    if (this.divTaxEntitySubscription) {
      this.divTaxEntitySubscription.unsubscribe()
    }
  }

  private updateForm(): void {
    const lijst = this.aangifte.opgaafDb?.opgaafSpecificaties || [];
    const formArray = this.opgaafFg.get('opgaafSpecificaties') as FormArray;
    const focusedControl = this.focusedElementId ? document.getElementById(this.focusedElementId) as HTMLElement : null;
    while (formArray.length > lijst.length) {
      formArray.removeAt(formArray.length - 1);
    }

    for (let i = 0; i < lijst.length; i++) {
      const pc = lijst[i];
      if (pc.postCodeGerechtigde) {
        pc.postCodeGerechtigde = this.formatPostcode(pc.postCodeGerechtigde);
      }

      if (i < formArray.length) {
        const control = formArray.at(i) as FormGroup;
        control.patchValue(lijst[i]);
      } else {
        const formGroup = this.createFormGroup(lijst[i])
        formArray.push(formGroup);
      }
    }
    if (focusedControl && document.contains(focusedControl)) {
      focusedControl.focus();
    }
  }

  saveForm(): void {
      this.opgaafFg.updateValueAndValidity()
      this.divTaxEntity.aangifte = {
        ...this.aangifte,
        opgaafDb: {
          ...this.aangifte.opgaafDb,
          bedragDividenduitkering: this.opgaafFg.value.bedragDividenduitkering,
          bedragNominaalGestortKapitaal: this.opgaafFg.value.bedragNominaalGestortKapitaal,
          totaalAantalStemgerechtigdeAandelen: this.opgaafFg.value.totaalAantalStemgerechtigdeAandelen,
          opgaafSpecificaties: this.opgaafFg.value.opgaafSpecificaties,
      },
      } as Dividendbelasting;
      this.dataService.updateDividendTaxEntity(this.divTaxEntity);
  }

  formatPostcode(postcode: string | null | undefined): string {
    if (!postcode) return '';
    const cleanedPostcode = postcode.replace(/[^a-zA-Z0-9]/g, '');
    if (cleanedPostcode.length >= 4) {
      const cijfers = cleanedPostcode.substring(0, 4).replace(/\D/g, ''); // Alleen cijfers
      const letters = cleanedPostcode.substring(4, 6).replace(/[^a-zA-Z]/g, '').toUpperCase(); // Alleen letters
      return `${cijfers}${letters}`;
    }
    return cleanedPostcode;
  }
}
